import { render, staticRenderFns } from "./preview-theme-banner.vue?vue&type=template&id=34be51ed"
import script from "./preview-theme-banner.vue?vue&type=script&lang=js"
export * from "./preview-theme-banner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports